<script setup lang="ts">
/**
 * The app's chrome glyphs.
 *
 * The drawings moved to `src/lib/icons.ts` — one table for the whole app, so `pen` here and
 * `pencil` in the radio cannot drift into two different pencils again. The name and the `size`
 * prop are unchanged; every call site keeps working.
 */
import Glyph from './Glyph.vue';

defineProps<{ name: string; size?: number }>();
</script>

<template>
  <Glyph :name="name" :size="size" />
</template>
